import { atom } from 'jotai';

/**
 * When true, the report subtree renders in "print mode":
 * all collapsed evidence rows expand, truncation caps are lifted,
 * and UI-only affordances (toggles, overflow buttons) hide.
 * Flipped on by the export action; reset by the browser's `afterprint` event.
 */
export const printModeAtom = atom<boolean>(false);
